<div class="counter_pill" *ngIf="healthCheck.kpis.length; else noKpis">
  <div class="inner_pill">
    <div class="box_lap">
      <span class="badge bg-primary gray_pill">{{
        healthCheck.count.GREY || 0
      }}</span>
      <span class="badge bg-primary green_pill">{{
        healthCheck.count.GREEN || 0
      }}</span>
      <span class="badge bg-primary yellow_pill">{{
        healthCheck.count.YELLOW || 0
      }}</span>
      <span class="badge bg-primary red_pill">{{
        healthCheck.count.RED || 0
      }}</span>
      <div class="dropdown">
        <button
          class="dropdown-toggle plus_pill"
          type="button"
          id="HealthCheckdropdownMenu"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        ></button>
        <ul
          class="dropdown-menu pill_drop"
          aria-labelledby="HealthCheckdropdownMenu"
        >
          <li *ngFor="let kpi of healthCheck.kpis">
            <a
              class="dropdown-item"
              [ngClass]="getHealthKpiClass(kpi.status_text)"
              [routerLink]="[
                '/dashboard',
                surveyId,
                { activeTab: 'HEALTH_CHECKS' }
              ]"
              >{{ kpi.name }}</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <a
    class="survey-link"
    [routerLink]="['/dashboard', surveyId, { activeTab: 'HEALTH_CHECKS' }]"
  >
    SEE MORE IN DETAILS <i class="fa fa-angle-right" aria-hidden="true"></i>
  </a>
</div>
<ng-template data-no-kpi="no-data-template" #noKpis>
  <p data-no-kpi="no-kpi">No Data Available</p>
</ng-template>
